import { addPageStore } from '../store';
import { MyProjectStore } from './me/store/MyProjectStore';

export function registerPagesStore(): Promise<any> {
    // addPageStore('users', UsersPageStore);
    return Promise.resolve(true);
}
